// extracted by mini-css-extract-plugin
export default {"heading":"heading--2LRJ7","form":"form--HDrjJ","primary":"primary--2zN0B"};